<template>
    <el-dialog :title="$t('shops.ownerLoginRecord')" :visible.sync="dialogVisible" width="60%" append-to-body>
        <el-table :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" :label="$t('shops.loginUserName')" align="center"/>
            <el-table-column prop="tel" :label="$t('shops.contactNumber')" align="center"/>
            <el-table-column prop="agreeTime" :label="$t('shops.loginTime')" align="center"/>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="pagination.current" :page-sizes="[10, 20, 30]"
                       :page-size="pagination.size"
                       layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"
                       style="margin-top: 20px; text-align: right">
        </el-pagination>
    </el-dialog>
</template>

<script>
import { queryOwnerUserLoginRecord } from '@/api/room/shopsApi'

export default {
    name: 'OwnerUserLoginRecordDialog',
    data() {
        return {
            dialogVisible: false,
            loading: false,
            tel: '',
            tableData: [],
            pagination: {
                current: 1,
                size: 10,
                total: 0
            }
        }
    },
    methods: {
        open(row) {
            this.tel = row.link || row.tel || ''
            this.dialogVisible = true
            this.pagination.current = 1
            this.loadData()
        },
        loadData() {
            this.loading = true
            queryOwnerUserLoginRecord({
                tel: this.tel,
                page: this.pagination.current,
                row: this.pagination.size
            })
                .then(res => {
                    this.tableData = res.data || []
                    this.pagination.total = res.total || 0
                })
                .catch(error => {
                    console.error(error)
                    this.$message.error(error.message || this.$t('common.requestError'))
                })
                .finally(() => {
                    this.loading = false
                })
        },
        handleSizeChange(size) {
            this.pagination.size = size
            this.loadData()
        },
        handleCurrentChange(page) {
            this.pagination.current = page
            this.loadData()
        }
    }
}
</script>
